var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTrash = function SvgTrash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6 12c-1 0-1.8.8-1.8 1.8v9.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-9.4c-.2-1-1-1.8-1.8-1.8m-5.2 0c-.8 0-1.6.8-1.6 1.8v9.4c0 1 .8 1.8 1.8 1.8s1.8-.8 1.8-1.8v-9.4c-.2-1-1-1.8-2-1.8m.2-10.4c-1 0-1.8.8-1.8 1.8s.8 1.8 1.8 1.8h4.8c1 0 1.8-.8 1.8-1.8s-.8-1.8-1.8-1.8z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4 26.6v-17h1.8c1 0 1.8-.8 1.8-1.8S28.2 6 27.2 6H4.8C3.8 6.2 3 7 3 8s.8 1.8 1.8 1.8h1.8v17c0 2 1.6 3.8 3.8 3.8h11.4c2-.3 3.6-1.8 3.6-4m-15.4 0v-17h12v17c0 .2-.2.4-.4.4H10.4c-.2 0-.4-.2-.4-.4"
  })));
};
export default SvgTrash;